export default "__VITE_ASSET__55173758__"